import { Header } from '@/components/Header/Header'
import { GoogleAnalytics, GoogleTagManager } from '@next/third-parties/google'
import { useBlocklist } from 'blocklist'
import Head from 'next/head'
import React, { ReactNode } from 'react'
import { Icon, Text, View, WarningCircle } from 'reshaped'
import { useAccount } from 'wagmi'

type LayoutProps = {
  children: ReactNode
  title?: string
  description?: string
  claimSuccess?: boolean
}

export function Layout({
  children,
  title = '$ZORA Claim',
  description = 'Check your $ZORA eligibility',
  claimSuccess,
}: LayoutProps) {
  const { address } = useAccount()
  const isBlocked = useBlocklist(address)

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="twitter:image" content="https://claim.zora.co/assets/og-image.jpeg" />
        <meta name="og:image" content="https://claim.zora.co/assets/og-image.jpeg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
        {claimSuccess && <meta name="apple-itunes-app" content="app-id=6474192103" />}
      </Head>
      <GoogleTagManager
        gtmId={process.env.NEXT_PUBLIC_TOKEN_CLAIM_GOOGLE_TAG_MANAGER_ID!}
      />
      <GoogleAnalytics gaId={process.env.NEXT_PUBLIC_TOKEN_CLAIM_GOOGLE_ANALYTICS_ID!} />
      <View
        position="relative"
        direction="column"
        width="100%"
        gap={{ s: 8, m: 18 }}
        maxWidth={{ s: '100%', m: '1280px' }}
        paddingTop={12}
        attributes={{
          style: {
            margin: '0 auto',
          },
        }}
      >
        <View position="relative" zIndex={10}>
          <Header />
        </View>
        {isBlocked ? (
          <View align="center" gap={4}>
            <View direction="row" align="center" gap={2}>
              <Icon svg={WarningCircle} size={10} color="critical" />
              <Text variant="featured-1" color="critical">
                Blocked
              </Text>
            </View>
            <Text variant="body-1" color="neutral" align="center">
              The connected address is not permitted to access this site.
              <br />
              Please try connecting with a different wallet.
            </Text>
          </View>
        ) : (
          <View as="main" grow position="relative" zIndex={1}>
            {children}
          </View>
        )}
      </View>
    </>
  )
}
